module.exports = __webpack_public_path__ + "media/testimonials/customer-6-e120b417.png";